import React from 'react'

import {
  confirmSignIn,
  rememberDevice as cognitoRememberDevice,
  fetchAuthSession,
} from 'aws-amplify/auth'
import { useNavigate } from 'react-router'
import { login } from 'src/legacy_modules/auth/login/request'
import { routes } from 'src/legacy_modules/routes'
import { useRequestState } from 'src/legacy_modules/server/use-request-state'

import { IProps as ITwoFactorProps, TwoFactor } from './two-factor'
import { usePostLoginNavigation } from '../hooks/usePostLoginNavigation'

export const TwoFactorContainer: React.FC<{}> = () => {
  const {
    requestDone,
    requestFailed,
    requestStarted,
    requesting,
    errorMessage,
  } = useRequestState()
  const navigate = useNavigate()

  const { jumpAfterLogin } = usePostLoginNavigation()

  const onCancel = () => navigate(routes.login)

  const onSubmit: ITwoFactorProps['onSubmit'] = async ({
    authCode,
    rememberDevice,
  }) => {
    try {
      requestStarted()
      await confirmSignIn({
        challengeResponse: authCode,
      })

      if (rememberDevice) {
        await cognitoRememberDevice()
      }

      const session = await fetchAuthSession()
      const idToken = session.tokens?.idToken?.toString()
      if (!idToken) {
        requestFailed(
          'セッションの取得に失敗しました。時間を置いて再度お試し下さい。',
        )
        return
      }

      await login(idToken, false)
      await jumpAfterLogin()
    } catch (error) {
      if (error instanceof Error) {
        if (error.name === 'ExpiredCodeException') {
          requestFailed('認証コードの有効期限が切れています。')
          return
        }
        if (error.name === 'CodeMismatchException') {
          requestFailed('認証コードが誤っています。')
          return
        }
        // cognitoのパスワード認証→TOTP認証間のセッションが切れた場合
        if (
          error.name === 'NotAuthorizedException' &&
          error.message === 'Invalid session for the user, session is expired.'
        ) {
          requestFailed(
            'セッションの有効期限が切れております。再度ログイン画面よりログイン下さい。',
          )
        }
      }
      requestFailed('問題が発生しました。時間を置いて再度お試し下さい。')
    } finally {
      requestDone()
    }
  }

  return (
    <TwoFactor
      errorMessage={errorMessage}
      requesting={requesting}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  )
}
